import { render, staticRenderFns } from "./ClientSapsTab.vue?vue&type=template&id=8c43ca28"
import script from "./ClientSapsTab.vue?vue&type=script&lang=js"
export * from "./ClientSapsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports